import React, { useState, useEffect } from 'react';

// Notification Bell Component
export const NotificationBell = ({ 
  pendingFeedbackNotifications,
  pendingProposalNotifications,
  pendingMentorRequestNotifications,
  pendingLorRequestNotifications,
  pendingTranscriptRequestNotifications,
  pendingProjectProposalNotifications,
  showNotificationDropdown, 
  setShowNotificationDropdown 
}) => {
  const totalCount = pendingFeedbackNotifications.length + 
                     (pendingProposalNotifications?.length || 0) + 
                     (pendingMentorRequestNotifications?.length || 0) + 
                     (pendingLorRequestNotifications?.length || 0) +
                     (pendingTranscriptRequestNotifications?.length || 0) +
                     (pendingProjectProposalNotifications?.length || 0);
  
  return (
    <div className="notification-badge">
      <div 
        className="notification-bell"
        onClick={() => setShowNotificationDropdown(!showNotificationDropdown)}
      >
        <i className="fa-solid fa-bell"></i>
        {totalCount > 0 && (
          <span className="badge-count">{totalCount}</span>
        )}
      </div>
    </div>
  );
};

// Notification Dropdown Component
export const NotificationDropdown = ({ 
  pendingFeedbackNotifications, 
  pendingProposalNotifications,
  pendingMentorRequestNotifications,
  pendingLorRequestNotifications,
  pendingTranscriptRequestNotifications,
  pendingProjectProposalNotifications,
  handleNotificationClick 
}) => {
  const totalNotifications = pendingFeedbackNotifications.length + 
                           pendingProposalNotifications.length + 
                           (pendingMentorRequestNotifications?.length || 0) + 
                           (pendingLorRequestNotifications?.length || 0) + 
                           (pendingTranscriptRequestNotifications?.length || 0) +
                           (pendingProjectProposalNotifications?.length || 0);
  
  return (
    <div className="notification-dropdown">
      <div className="notification-header">
        <h3>Notifications ({totalNotifications})</h3>
      </div>
      
      {totalNotifications === 0 ? (
        <div className="notification-empty">
          No pending notifications
        </div>
      ) : (
        <div className="notification-content">
          {/* Mentor Request Notifications */}
          {pendingMentorRequestNotifications && pendingMentorRequestNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Mentor Requests ({pendingMentorRequestNotifications.length})</h4>
              {pendingMentorRequestNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread proposal-notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.message}</div>
                  <div className="notification-student">Mentor: {notification.mentorName}</div>
                  <div className="notification-time">
                    {notification.createdAt?.toDate?.().toLocaleDateString() || 'Recently'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Letter of Recommendation Request Notifications */}
          {pendingLorRequestNotifications && pendingLorRequestNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Letter of Rec Requests ({pendingLorRequestNotifications.length})</h4>
              {pendingLorRequestNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread proposal-notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.message}</div>
                  <div className="notification-student">{notification.studentName}</div>
                  <div className="notification-time">
                    {new Date(notification.timestamp).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Transcript Request Notifications */}
          {pendingTranscriptRequestNotifications && pendingTranscriptRequestNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Transcript Requests ({pendingTranscriptRequestNotifications.length})</h4>
              {pendingTranscriptRequestNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread proposal-notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.message}</div>
                  <div className="notification-student">{notification.studentName}</div>
                  <div className="notification-time">
                    {new Date(notification.timestamp).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Project Proposal Notifications */}
          {pendingProjectProposalNotifications && pendingProjectProposalNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Project Proposals ({pendingProjectProposalNotifications.length})</h4>
              {pendingProjectProposalNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread proposal-notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.message}</div>
                  <div className="notification-student">{notification.studentName}</div>
                  <div className="notification-time">
                    {new Date(notification.timestamp).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Class Proposal Notifications */}
          {pendingProposalNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Class Proposals ({pendingProposalNotifications.length})</h4>
              {pendingProposalNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread proposal-notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.className}</div>
                  <div className="notification-student">{notification.studentName}</div>
                  <div className="notification-time">
                    {new Date(notification.timestamp).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}
          
          {/* Feedback Notifications */}
          {pendingFeedbackNotifications.length > 0 && (
            <div className="notification-section">
              <h4>Pending Feedback ({pendingFeedbackNotifications.length})</h4>
              {pendingFeedbackNotifications.map(notification => (
                <div 
                  key={notification.id}
                  className="notification-item unread"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-title">{notification.postTitle}</div>
                  <div className="notification-student">{notification.studentName}</div>
                  <div className="notification-time">
                    {new Date(notification.postDate).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// Notification Click Handler
export const createNotificationClickHandler = ({
  setShowNotificationDropdown,
  setTeacherViewMode,
  students,
  setSelectedStudentUid,
  setSelectedStudentForFeedback,
  setSelectedTag,
  navigateToPost
}) => {
  return (notification) => {
    // Close the dropdown
    setShowNotificationDropdown(false);
    
    // Check if this is a class proposal notification
    if (notification.type === 'proposal') {
      // Switch to class management view
      setTeacherViewMode('class-management');
      return;
    }

    // Check if this is a mentor request notification
    if (notification.type === 'mentor-request') {
      // Switch to mentor management view
      setTeacherViewMode('mentor-management');
      // Don't mark as read - will be removed when request is marked complete
      return;
    }

    // Check if this is a letter of recommendation request notification
    if (notification.type === 'lor-request') {
      // Switch to lor management view
      setTeacherViewMode('lor-management');
      // Scroll to the specific request after a short delay to ensure DOM is updated
      setTimeout(() => {
        const requestElement = document.getElementById(`lor-request-${notification.requestId}`);
        if (requestElement) {
          requestElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Add highlight class (same as posts)
          requestElement.classList.add('highlighted');
          // Remove highlight after 3 seconds
          setTimeout(() => {
            requestElement.classList.remove('highlighted');
          }, 3000);
        }
      }, 100);
      return;
    }

    // Check if this is a project proposal notification
    if (notification.type === 'project-proposal') {
      // Switch to project management view
      setTeacherViewMode('project-management');
      // Scroll to the specific proposal after a short delay to ensure DOM is updated
      setTimeout(() => {
        const proposalElement = document.getElementById(`project-proposal-${notification.proposalId}`);
        if (proposalElement) {
          proposalElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Add highlight class (same as posts)
          proposalElement.classList.add('highlighted');
          // Remove highlight after 3 seconds
          setTimeout(() => {
            proposalElement.classList.remove('highlighted');
          }, 3000);
        }
      }, 100);
      return;
    }

    // Check if this is a transcript request notification
    if (notification.type === 'transcript-request') {
      // Switch to lor management view (where transcript requests are also shown)
      setTeacherViewMode('lor-management');
      // Scroll to the specific request after a short delay to ensure DOM is updated
      setTimeout(() => {
        const requestElement = document.getElementById(`transcript-request-${notification.requestId}`);
        if (requestElement) {
          requestElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Add highlight class (same as posts)
          requestElement.classList.add('highlighted');
          // Remove highlight after 2 seconds
          setTimeout(() => {
            requestElement.classList.remove('highlighted');
          }, 2000);
        }
      }, 100);
      return;
    }
    
    // Otherwise, handle as feedback notification
    // Switch to student feedback view
    setTeacherViewMode('student-feedback');
    
    // Find and select the student
    const student = students.find(s => s.id === notification.studentId);
    if (student) {
      setSelectedStudentUid(student.id);
      setSelectedStudentForFeedback(student);
    }
    
    // Clear the tag filter so teacher can see all skills for this post
    setSelectedTag('all');
    
    // Use the existing navigateToPost function which handles grade expansion and scrolling
    navigateToPost(notification.postId);
  };
};

// Notification Logic Hook
export const useNotificationSystem = ({ 
  userProfile, 
  posts, 
  students, 
  tagFeedbacks, 
  classProposals,
  currentUser,
  mentorRequests,
  lorRequests,
  transcriptRequests,
  projectProposals
}) => {
  const [pendingFeedbackNotifications, setPendingFeedbackNotifications] = useState([]);
  const [pendingProposalNotifications, setPendingProposalNotifications] = useState([]);
  const [pendingMentorRequestNotifications, setPendingMentorRequestNotifications] = useState([]);
  const [pendingLorRequestNotifications, setPendingLorRequestNotifications] = useState([]);
  const [pendingTranscriptRequestNotifications, setPendingTranscriptRequestNotifications] = useState([]);
  const [pendingProjectProposalNotifications, setPendingProjectProposalNotifications] = useState([]);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);

  // Update pending feedback notifications
  useEffect(() => {
    if (userProfile?.role === 'teacher' && posts.length > 0 && students.length > 0) {
      
      // Group notifications by post to avoid duplicates
      const postNotifications = new Map();
      
      // Get all posts that have tagJustifications but no feedback from current teacher
      posts.forEach(post => {
        if (post.tagJustifications && post.tagJustifications.length > 0) {
          const skillsNeedingFeedback = [];
          
          post.tagJustifications.forEach(tagJustification => {
            const tag = tagJustification.tag;
            
            // Check if current teacher has already given feedback for this skill
            const teacherHasGivenFeedback = tagFeedbacks.some(tf => 
              tf.postId === post.id && 
              tf.tag === tag && 
              tf.teacherId === currentUser?.uid
            );
            
            if (!teacherHasGivenFeedback) {
              skillsNeedingFeedback.push({
                skill: tag,
                justification: tagJustification.justification
              });
            }
          });
          
          // If there are skills needing feedback, create a notification for this post
          if (skillsNeedingFeedback.length > 0) {
            // Find the student who created this post
            const student = students.find(s => s.id === post.userId);
            const studentName = student ? student.name : 'Unknown Student';
            
            postNotifications.set(post.id, {
              id: post.id,
              postId: post.id,
              postTitle: post.title,
              skillsNeedingFeedback: skillsNeedingFeedback,
              studentId: post.userId,
              studentName: studentName,
              postDate: post.timestamp,
              priority: 'medium' // Could be enhanced with priority logic
            });
          }
        }
      });
      
      // Convert map to array and sort by post date (newest first)
      const notificationsArray = Array.from(postNotifications.values())
        .sort((a, b) => new Date(b.postDate) - new Date(a.postDate));
      
      setPendingFeedbackNotifications(notificationsArray);
    } else {
      setPendingFeedbackNotifications([]);
    }
  }, [posts, students, tagFeedbacks, userProfile?.role, currentUser]);

  // Update pending class proposal notifications
  useEffect(() => {
    if (userProfile?.role === 'teacher' && classProposals.length > 0) {
      const proposalNotifications = classProposals.map(proposal => ({
        id: proposal.id,
        type: 'proposal',
        className: proposal.className,
        studentId: proposal.studentId,
        studentName: proposal.studentName,
        timestamp: proposal.timestamp,
        priority: 'high'
      }));
      
      setPendingProposalNotifications(proposalNotifications);
    } else {
      setPendingProposalNotifications([]);
    }
  }, [classProposals, userProfile?.role]);

  // Update pending mentor request notifications based on mentorRequests
  useEffect(() => {
    if (userProfile?.role === 'teacher' && mentorRequests && mentorRequests.length > 0) {
      // Filter for only pending requests and convert to notifications
      const pendingRequests = mentorRequests.filter(req => req.status === 'pending');
      
      const mentorNotifications = pendingRequests.map(request => ({
        id: request.id,
        type: 'mentor-request',
        requestId: request.id,
        mentorId: request.mentorId,
        mentorName: request.mentorName,
        studentId: request.studentId,
        studentName: request.studentName,
        message: `${request.studentName} requested to connect with mentor ${request.mentorName}`,
        createdAt: request.createdAt,
        priority: 'high'
      }));

      setPendingMentorRequestNotifications(mentorNotifications);
    } else {
      setPendingMentorRequestNotifications([]);
    }
  }, [userProfile?.role, mentorRequests]);

  // Update pending letter of recommendation request notifications
  useEffect(() => {
    if (userProfile?.role === 'teacher' && lorRequests && lorRequests.length > 0) {
      // Filter for only pending requests and convert to notifications
      const pendingRequests = lorRequests.filter(req => req.status === 'pending');
      
      const lorNotifications = pendingRequests.map(request => ({
        id: request.id,
        type: 'lor-request',
        requestId: request.id,
        studentId: request.studentId,
        studentName: request.studentName,
        programName: request.programName,
        deadline: request.deadline,
        message: `${request.studentName} requested a letter of recommendation for ${request.programName}`,
        timestamp: request.timestamp,
        priority: 'high'
      }));

      setPendingLorRequestNotifications(lorNotifications);
    } else {
      setPendingLorRequestNotifications([]);
    }
  }, [userProfile?.role, lorRequests]);

  // Update pending transcript request notifications
  useEffect(() => {
    if (userProfile?.role === 'teacher' && transcriptRequests && transcriptRequests.length > 0) {
      // Filter for only pending requests and convert to notifications
      const pendingRequests = transcriptRequests.filter(req => req.status === 'pending');
      
      const transcriptNotifications = pendingRequests.map(request => ({
        id: request.id,
        type: 'transcript-request',
        requestId: request.id,
        studentId: request.studentId,
        studentName: request.studentName,
        purpose: request.purpose,
        message: `${request.studentName} requested a transcript copy`,
        timestamp: request.timestamp,
        priority: 'high'
      }));

      setPendingTranscriptRequestNotifications(transcriptNotifications);
    } else {
      setPendingTranscriptRequestNotifications([]);
    }
  }, [userProfile?.role, transcriptRequests]);

  // Update pending project proposal notifications
  useEffect(() => {
    if (userProfile?.role === 'teacher' && projectProposals && projectProposals.length > 0) {
      // Filter for only pending proposals and convert to notifications
      const pendingProposals = projectProposals.filter(proposal => proposal.status === 'pending');
      
      const projectProposalNotifications = pendingProposals.map(proposal => ({
        id: proposal.id,
        type: 'project-proposal',
        proposalId: proposal.id,
        studentId: proposal.studentId,
        studentName: proposal.studentName,
        title: proposal.title,
        message: `${proposal.studentName} submitted a project proposal: ${proposal.title}`,
        timestamp: proposal.timestamp,
        priority: 'high'
      }));

      setPendingProjectProposalNotifications(projectProposalNotifications);
    } else {
      setPendingProjectProposalNotifications([]);
    }
  }, [userProfile?.role, projectProposals]);

  // Handle dropdown positioning
  useEffect(() => {
    if (showNotificationDropdown) {
      const bell = document.querySelector('.notification-bell');
      const dropdown = document.querySelector('.notification-dropdown');
      
      if (bell && dropdown) {
        const bellRect = bell.getBoundingClientRect();
        
        // Position dropdown to align right edge with bell's right edge
        const rightPosition = window.innerWidth - bellRect.right;
        dropdown.style.right = `${rightPosition}px`;
        dropdown.style.top = `${bellRect.bottom + 10}px`;
      }
    }
  }, [showNotificationDropdown]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showNotificationDropdown && 
          !event.target.closest('.notification-dropdown') && 
          !event.target.closest('.notification-bell')) {
        setShowNotificationDropdown(false);
      }
    };

    if (showNotificationDropdown) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showNotificationDropdown]);

  return {
    pendingFeedbackNotifications,
    pendingProposalNotifications,
    pendingMentorRequestNotifications,
    pendingLorRequestNotifications,
    pendingTranscriptRequestNotifications,
    pendingProjectProposalNotifications,
    showNotificationDropdown,
    setShowNotificationDropdown
  };
};

const notificationComponents = {
  NotificationBell,
  NotificationDropdown,
  createNotificationClickHandler,
  useNotificationSystem
};

export default notificationComponents;
